/* Constants */
import { env } from "../../constants"


/* The words of a rate — the form and the card say them under the stars */
export const RATE_WORDS = {
    1: "Ужасно",
    2: "Плохо",
    3: "Нормально",
    4: "Хорошо",
    5: "Отлично"
}

/* The colour of a rate: the bad ones are red, the middle one is orange, the good ones are green */
export const rateAccentOf = rate => {

    const value = parseInt(rate)

    if (value <= 2) {
        return "red"
    }

    if (value === 3) {
        return "orange"
    }

    return "green"
}

/* The reasons of a complaint — the same keys and words Bookify Pro shows the point */
export const REASONS = {
    fake: { text: "Отзыв не от клиента", hint: "Этот человек не был в организации" },
    offensive: { text: "Оскорбления или мат", hint: "В тексте есть грубость или угрозы" },
    competitor: { text: "Заказной отзыв", hint: "Похоже на отзыв конкурента" },
    private: { text: "Личные данные", hint: "В тексте телефон, адрес или имя другого человека" },
    another: { text: "Другое", hint: "Точка описала причину сама" }
}

export const reasonOf = key => {
    return REASONS[key] ? REASONS[key] : { text: key ? key : "Без причины", hint: "" }
}

/* The states of a complaint */
export const COMPLAINT_STATUSES = {
    0: { text: "Жалоба ждёт решения", short: "Жалоба", accent: "orange" },
    1: { text: "Жалоба принята", short: "Принята", accent: "red" },
    2: { text: "Жалоба отклонена", short: "Отклонена", accent: "grey" }
}

/* The photos of a review come from the list as one line */
export const imagesOf = value => {

    if (Array.isArray(value)) {
        return value.map(item => item.image ? item.image : item)
    }

    if (value && `${value}`.length > 0) {
        return `${value}`.split(",")
    }

    return []
}

export const photoOf = image => `${env.mediapoint}reviews/${image}`

/* Who wrote the review: the name of the account, else the name written in the review */
export const authorOf = review => {

    const name = review.userName && `${review.userName}`.trim().length > 0 ? review.userName : review.user

    if (name && `${name}`.trim().length > 0) {
        return `${name}`.trim()
    }

    return null
}

/* A rating with one digit after the point, the Russian way */
export const ratingOf = value => {

    const number = parseFloat(value)

    if (!number) {
        return "—"
    }

    return number.toFixed(1).replace(".", ",")
}
